export interface Comic {
  id: number;
  title: string;
  altTitle: string;
  author: string;
  artist: string;
  cover: string;
  description: string;
  category: string;
  categorySlug: string;
  status: '连载中' | '已完结';
  rating: number;
  views: string;
  favorites: string;
  chapters: number;
  updateDate: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我独自升级',
    altTitle: 'Solo Leveling',
    author: 'Chugong',
    artist: 'DUBU（REDICE STUDIO）',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20solo%20leveling%20warrior%20in%20dark%20armor%20holding%20sword%20dramatic%20lighting%20dark%20background%20epic%20fantasy%20art%20style%20manga%20cover%20illustration%20cool%20vibe%20shadow%20monarch%20aesthetic&width=400&height=560&seq=comic-cover-01&orientation=portrait',
    description: '十多年前，世界各地出现了连接异次元与现世的"传送门"，而觉醒了特殊能力被称为"猎人"的人们，进入传送门地下城以狩猎魔兽为生。然而，并非所有猎人都实力强劲。成振宇正是被称为"人类最弱兵器"的E级猎人之一。某一天，他在地下城中触发了隐藏任务，获得了可以无限升级的"系统"。从此，他从最弱一步步成长为最强猎人，誓要揭开传送门背后的真相。',
    category: '热血少年',
    categorySlug: 'action',
    status: '已完结',
    rating: 9.8,
    views: '1.2亿',
    favorites: '890万',
    chapters: 179,
    updateDate: '2024-12-20',
    tags: ['热血', '战斗', '系统流', '升级', '异能'],
    isHot: true,
    isNew: false,
  },
  {
    id: 2,
    title: '全知读者视角',
    altTitle: 'Omniscient Reader\'s Viewpoint',
    author: 'sing N song',
    artist: 'Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20omniscient%20reader%20male%20protagonist%20with%20glasses%20holding%20a%20book%20fantasy%20apocalyptic%20background%20constellation%20stars%20dramatic%20manga%20cover%20style%20dark%20and%20mysterious%20atmosphere&width=400&height=560&seq=comic-cover-02&orientation=portrait',
    description: '金独子是一名普通的上班族，唯一的爱好就是在通勤路上阅读一本名叫《在灭亡世界存活下来的三种方法》的网络小说。十年间，只有他一个人坚持读完了这部3149章的小说。然而当小说完结的那一天，小说的世界竟然变成了现实——世界发生了毁灭性的变化，怪物肆虐。而作为全世界唯一知道故事结局的人，金独子获得了在这个灭亡世界中存活下来的机会。',
    category: '热血少年',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.7,
    views: '9600万',
    favorites: '720万',
    chapters: 236,
    updateDate: '2026-07-05',
    tags: ['奇幻', '末日', '系统流', '剧情', '智力战'],
    isHot: true,
    isNew: false,
  },
  {
    id: 3,
    title: '再婚皇后',
    altTitle: 'The Remarried Empress',
    author: 'Alpha Tart',
    artist: 'Sumpul',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20elegant%20empress%20in%20luxurious%20golden%20royal%20gown%20romantic%20historical%20palace%20setting%20beautiful%20female%20protagonist%20manga%20cover%20style%20soft%20warm%20lighting%20regal%20atmosphere&width=400&height=560&seq=comic-cover-03&orientation=portrait',
    description: '娜维埃是东方帝国的皇后，聪慧、美丽、高贵。当她发现皇帝丈夫带回了情妇并将她带在身边时，她的尊严受到了极大的挑衅。面对众人的议论与同情，娜维埃做出了一个震惊所有人的决定——她要离婚再嫁，成为另一个帝国的皇后。而那位传说中冷酷无情、从未露面的西方帝国皇帝，究竟是怎样的人？',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.5,
    views: '7800万',
    favorites: '560万',
    chapters: 198,
    updateDate: '2026-07-06',
    tags: ['宫廷', '逆袭', '女强', '恋爱', '复仇'],
    isHot: true,
    isNew: false,
  },
  {
    id: 4,
    title: '我夺走了公爵的初夜',
    altTitle: 'I Stole the Duke\'s First Night',
    author: 'Hwang DoTol',
    artist: 'MingKit',
    cover: 'https://readdy.ai/api/search-image?width=400&height=560&seq=comic-cover-04&orientation=portrait&query=Korean%20manhwa%20romantic%20couple%20duke%20and%20lady%20in%20elegant%19th%20century%20clothing%20close%20embrace%20soft%20romantic%20atmosphere%20historical%20romance%20manga%20cover%20style%20warm%20pink%20tones',
    description: '蕾娜在意外中穿越到了小说世界，成为了一个即将被退婚的公爵小姐。在一次意外中，她与那位以冷酷无情闻名的公爵一夜缠绵。本以为只是一场意外，没想到公爵却对她穷追不舍。"既然你夺走了我的初夜，你就要对我负责。"蕾娜震惊地发现，这个传闻中的冷面公爵，私下里竟然如此粘人！',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.3,
    views: '6500万',
    favorites: '480万',
    chapters: 156,
    updateDate: '2026-07-07',
    tags: ['穿越', '恋爱', '甜宠', '宫廷', '搞笑'],
    isHot: false,
    isNew: true,
  },
  {
    id: 5,
    title: '甜蜜家园',
    altTitle: 'Sweet Home',
    author: 'Kim Carnby',
    artist: 'Hwang Young-chan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20monster%20apocalypse%20survivor%20in%20dark%20apartment%20building%20creepy%20atmosphere%20thriller%20manga%20cover%20style%20dark%20shadows%20monstrous%20creatures%20tense%20mood&width=400&height=560&seq=comic-cover-05&orientation=portrait',
    description: '车贤秀因遭受校园霸凌而将自己封闭在房间里，成为了一个彻底的家里蹲。在失去所有家人后，他搬进了一栋破旧的公寓楼，打算结束自己的生命。然而，世界突然发生了异变——人们开始变成可怕的怪物，公寓楼被封锁，幸存者们被困其中。贤秀发现自己的身体也开始发生变化，但他却拥有控制这种变化的特殊能力。',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '已完结',
    rating: 9.6,
    views: '8500万',
    favorites: '620万',
    chapters: 140,
    updateDate: '2024-08-15',
    tags: ['恐怖', '末世', '怪物', '生存', '人性'],
    isHot: true,
    isNew: false,
  },
  {
    id: 6,
    title: '神之塔',
    altTitle: 'Tower of God',
    author: 'SIU',
    artist: 'SIU',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20tower%20of%20god%20boy%20climbing%20mysterious%20tower%20fantasy%20adventure%20colorful%20vibrant%20manga%20cover%20style%20epic%20scale%20mysterious%20atmosphere%20magical%20elements&width=400&height=560&seq=comic-cover-06&orientation=portrait',
    description: '二十五之夜的少年，为了追寻唯一的朋友——蕾哈尔，来到了神秘的通天巨塔。在这座塔中，只要登顶就能获得一切：财富、荣耀、权力、复仇，甚至是神的力量。夜加入了一场残酷的登塔测试，与来自各处的挑战者一决高下。在这过程中，他结识了同伴，也遭遇了背叛，一步步揭开塔的秘密，以及关于自己身世的惊人真相。',
    category: '热血少年',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.4,
    views: '7200万',
    favorites: '550万',
    chapters: 610,
    updateDate: '2026-07-03',
    tags: ['冒险', '奇幻', '战斗', '友情', '成长'],
    isHot: false,
    isNew: false,
  },
  {
    id: 7,
    title: '不要小看青梅竹马',
    altTitle: 'Don\'t Underestimate the Childhood Friend',
    author: 'YeoNim',
    artist: 'Sanyong',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cute%20high%20school%20romance%20boy%20and%20girl%20childhood%20friends%20sweet%20school%20setting%20blossom%20trees%20romantic%20comedy%20manga%20cover%20style%20bright%20pastel%20colors&width=400&height=560&seq=comic-cover-07&orientation=portrait',
    description: '从小到大，林彩英一直默默暗恋着自己的青梅竹马韩宇镇。然而宇镇身边总是围绕着各种美女，而她这个"哥们"似乎永远只能站在朋友的位置上。忍无可忍的彩英决定改变——她开始学习化妆打扮，改变自己的形象。当全新的彩英出现在宇镇面前时，这位迟钝的青梅竹马终于开始意识到自己的心意。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.2,
    views: '4800万',
    favorites: '350万',
    chapters: 89,
    updateDate: '2026-07-04',
    tags: ['校园', '恋爱', '青梅竹马', '甜宠', '变身'],
    isHot: false,
    isNew: true,
  },
  {
    id: 8,
    title: '死期将至',
    altTitle: 'Death\'s Game',
    author: 'Lee Wonsik',
    artist: 'Ggulchan',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20death%20game%20grim%20reaper%20dark%20fantasy%20thriller%20mysterious%20figure%20in%20black%20hood%20holding%20cards%20dramatic%20manga%20cover%20style%20dark%20red%20and%20black%20tones&width=400&height=560&seq=comic-cover-08&orientation=portrait',
    description: '崔以在对生活失去希望后选择了死亡，却在冥界遇见了死神。死神对于他轻视生命的态度感到愤怒，对他降下了惩罚——他将被投入13个不同的身体中，经历13次死亡。如果他能在其中任何一次死亡经历中成功地活下去并改变那个人的命运，他就能获得重生的机会。一场与死亡赛跑的残酷游戏就此展开。',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '已完结',
    rating: 9.7,
    views: '5600万',
    favorites: '410万',
    chapters: 66,
    updateDate: '2024-11-30',
    tags: ['死亡', '轮回', '悬疑', '人性', '剧情'],
    isHot: false,
    isNew: false,
  },
  {
    id: 9,
    title: '剑尊归来',
    altTitle: 'Return of the Sword Master',
    author: 'LEE SeungHwan',
    artist: 'Studio JHS',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20ancient%20sword%20master%20warrior%20returning%20from%20death%20martial%20arts%20wuxia%20style%20long%20black%20hair%20holding%20sword%20dramatic%20pose%20manga%20cover%20style%20dark%20mountain%20background&width=400&height=560&seq=comic-cover-09&orientation=portrait',
    description: '武林至尊剑尊在击杀魔教教主后力竭而亡，当他再次睁开眼时，却发现自己重生在了现代的韩国。在这个灵气稀薄的现代世界，他用前世的绝世剑法横扫一切。但他逐渐发现，魔教的势力也跟随他穿越而来，潜伏在现代社会的黑暗角落。剑尊决定重整旗鼓，在这个陌生的世界中再次踏上斩妖除魔之路。',
    category: '热血少年',
    categorySlug: 'action',
    status: '连载中',
    rating: 9.5,
    views: '6100万',
    favorites: '450万',
    chapters: 128,
    updateDate: '2026-07-06',
    tags: ['武侠', '重生', '战斗', '热血', '都市'],
    isHot: false,
    isNew: true,
  },
  {
    id: 10,
    title: '完美的结婚公式',
    altTitle: 'Perfect Marriage Formula',
    author: 'Lee BomNal',
    artist: 'KANG NalLim',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20contract%20marriage%20romance%20CEO%20couple%20in%20modern%20luxurious%20penthouse%20setting%20elegant%20business%20attire%20romantic%20tension%20manga%20cover%20style%20warm%20golden%20lighting&width=400&height=560&seq=comic-cover-10&orientation=portrait',
    description: '韩幼琳为了偿还家族的巨额债务，被迫与冷酷的商业巨子姜泰赫签订了一年的契约婚姻。姜泰赫需要一个名义上的妻子来继承家业，而幼琳需要钱。两人约法三章，一年后离婚各不相干。然而，日复一日的相处中，冰冷的姜泰赫渐渐被幼琳的善良和坚强所打动，而幼琳也发现了姜泰赫冷酷外表下的温柔。契约婚姻，正在悄然变质。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.4,
    views: '5200万',
    favorites: '380万',
    chapters: 112,
    updateDate: '2026-07-07',
    tags: ['契约婚姻', '恋爱', '总裁', '甜宠', '都市'],
    isHot: false,
    isNew: false,
  },
  {
    id: 11,
    title: '寄生兽：灰暗',
    altTitle: 'Parasite: The Grey',
    author: 'Yeon Sang-ho',
    artist: 'RyU SiMin',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20parasite%20horror%20mutated%20creature%20taking%20over%20human%20body%20dark%20alley%20neon%20city%20lights%20sci%20fi%20thriller%20manga%20cover%20style%20creepy%20detailed%20monster%20art&width=400&height=560&seq=comic-cover-11&orientation=portrait',
    description: '不明寄生生物从空中降临，它们钻入人类的耳中，吃掉大脑，夺取身体的控制权。整个城市在短短几天内变成了人间地狱。幸存者们必须时刻保持警惕，因为你永远不知道身边的人是真人，还是已经被寄生生物控制的行尸走肉。秀仁在混乱中觉醒了特殊能力——她能够感应到寄生生物，成为人类最后的希望。',
    category: '悬疑惊悚',
    categorySlug: 'thriller',
    status: '连载中',
    rating: 9.3,
    views: '4300万',
    favorites: '310万',
    chapters: 58,
    updateDate: '2026-07-02',
    tags: ['科幻', '恐怖', '怪物', '生存', '末日'],
    isHot: false,
    isNew: true,
  },
  {
    id: 12,
    title: '网络小说的法则',
    altTitle: 'The Law of Webnovels',
    author: 'Yuhan',
    artist: 'AHIN',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20female%20college%20student%20reading%20web%20novel%20in%20cozy%20cafe%20fantasy%20elements%20floating%20around%20her%20whimsical%20modern%20fantasy%20manga%20cover%20style%20soft%20magical%20glow&width=400&height=560&seq=comic-cover-12&orientation=portrait',
    description: '大学生韩素敏是一个狂热的网络小说迷，尤其钟爱那些冷门的逆袭题材。某天，她一觉醒来，发现自己穿越到了自己最喜欢的网络小说世界里，成为了一个即将被毁掉的反派千金。熟知剧情的她决心改写自己的命运——利用对这个世界规则的理解，她一步步地化解危机，避开死亡flag。然而，她的举动却引起了小说中男主角的注意。',
    category: '浪漫爱情',
    categorySlug: 'romance',
    status: '连载中',
    rating: 9.1,
    views: '3900万',
    favorites: '290万',
    chapters: 95,
    updateDate: '2026-07-05',
    tags: ['穿越', '逆袭', '恋爱', '搞笑', '乙女向'],
    isHot: false,
    isNew: false,
  },
];

export const getHotComics = (): Comic[] => comics.filter((c) => c.isHot);
export const getNewComics = (): Comic[] => comics.filter((c) => c.isNew);
export const getComicsByCategory = (slug: string): Comic[] => comics.filter((c) => c.categorySlug === slug);
export const getComicById = (id: number): Comic | undefined => comics.find((c) => c.id === id);